import { useState } from "react"
import { useTranslation } from "react-i18next"
import { IoIosInformationCircle } from "react-icons/io"
import formatter from "../../../constants/currencyFormatter"
import InfoItem from "../../common/InfoItem"
import BreakdownItem from "../MakePayment/BreakdownItem"
import ReusableDrawer from "../../common/ReusableDrawer"
import { colors } from "../../../utilities/colors"

export default function TxnUnitBreakdown({ unit }) {
  const { t } = useTranslation()
  const [showFeeBreakdown, setShowFeeBreakdown] = useState(false)

  const paymentBreakdown = unit['payment_breakdown'] || {}
  const feesBreakdown = paymentBreakdown['fees_breakdown'] || []
  const principalPaid = parseFloat(paymentBreakdown['principal_paid'] || 0)
  const interestPaid = parseFloat(paymentBreakdown['interest_paid'] || 0)
  const feesPaid = parseFloat(paymentBreakdown['fees_paid'] || 0)
  const insuranceFeesPaid = parseFloat(paymentBreakdown['insurance_fees_paid'] || 0)
  const reservesAdded = parseFloat(paymentBreakdown['reserves_added'] || 0)
  const totalFees = feesPaid + insuranceFeesPaid
  const hasFeeBreakdown = feesBreakdown.length > 0 || insuranceFeesPaid > 0

  return (
    <>
      <InfoItem title={unit.vin}>
        <div className="flex flex-col pl-4">
          <div>{[unit.year, unit.color, unit.make, unit.model].filter(Boolean).join(' ')}</div>
          <div>{`${t('Principal')} - ${formatter.format(principalPaid)}`}</div>
          <div>{`${t('Interest')} - ${formatter.format(interestPaid)}`}</div>
          <div className="flex items-center gap-1">
            {`${t('Fees')} - ${formatter.format(totalFees)}`}
            {hasFeeBreakdown &&
              <IoIosInformationCircle
                className="hover:cursor-pointer"
                onClick={() => setShowFeeBreakdown(true)}
              />
            }
          </div>
          {reservesAdded > 0 &&
            <div>{`${t('Reserves Added')} - ${formatter.format(reservesAdded)}`}</div>
          }
        </div>
      </InfoItem>

      {showFeeBreakdown &&
        <ReusableDrawer
          isOpen={showFeeBreakdown}
          onClose={() => setShowFeeBreakdown(false)}
          placement="bottom"
          height="50dvh"
          zIndex={2147483647}
          title={t('Fee Breakdown')}
          bgColor={colors.grey900}
          titleStyle="lg:flex lg:justify-center"
          bodyStyle="md:flex md:items-center md:justify-center"
          bodyContent={
            <div className="lg:w-1/3 md:w-2/3 grid grid-cols-2 gap-y-1 text-sm">
              {feesBreakdown.map((fee) => (
                <BreakdownItem
                  key={fee.txn_line_id}
                  title={fee.memo}
                  amount={formatter.format(fee.amount)}
                />
              ))}
              {insuranceFeesPaid > 0 &&
                <BreakdownItem
                  title={t('Insurance Fees')}
                  amount={formatter.format(insuranceFeesPaid)}
                />
              }
            </div>
          }
        />
      }
    </>
  )
}
